import { useCallback, useEffect, useState } from 'react'
import { useIsAuthenticated } from 'state/profile/hooks'
import { FetchStatus } from 'state/types'

const useRestData: <T>(
  endpointCallback: () => Promise<T>,
  emptyValue: T,
) => [fetchStatus: FetchStatus, data: T, fetchData: () => void] = (endpointCallback, emptyValue) => {
  const isAuthenticated = useIsAuthenticated()
  const [data, setData] = useState(emptyValue)
  const [fetchStatus, setFetchStatus] = useState(FetchStatus.NOT_FETCHED)

  const fetchData = useCallback(async () => {
    if (fetchStatus === FetchStatus.FETCHING) return

    try {
      setFetchStatus(FetchStatus.FETCHING)
      setData(emptyValue)
      const response = await endpointCallback()
      setData(response)
      setFetchStatus(FetchStatus.FETCHED)
    } catch (error) {
      console.error(error)
      setData(emptyValue)
      setFetchStatus(FetchStatus.FAILED)
    }
  }, [emptyValue, endpointCallback, fetchStatus])

  useEffect(() => {
    if (!isAuthenticated) {
      setData(emptyValue)
      setFetchStatus(FetchStatus.NOT_FETCHED)
    }
  }, [emptyValue, isAuthenticated])

  useEffect(() => {
    if (isAuthenticated && fetchStatus === FetchStatus.NOT_FETCHED) {
      fetchData()
    }
  }, [isAuthenticated, fetchData, fetchStatus])

  return [fetchStatus, data, fetchData]
}

export default useRestData
